import { makeAutoObservable } from "mobx";

class AppStore {
	isLoading: boolean = false
	constructor() {
		makeAutoObservable(this);
	}
	setIsLoading(isLoading: boolean) {
		this.isLoading = isLoading
	}
}

export const appStore = new AppStore()
